import { notificationService } from '@redislabsdev/cloud-ui-mfe-events';
import { toast } from '@redis-ui/components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { extractError } from '../../../../utils/helpers/extractError';

const useNotificationEvents = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const unsubscribe = notificationService.subscribe((event) => {
      let message = '';
      const { description } = event.payload;

      switch (event.type) {
        case 'error':
          message = event.payload.message || t(extractError(event.payload.smBadException)?.message);

          if (message) {
            toast.danger({ message, description });
          }

          break;
        case 'success':
          if (event.payload.message) {
            toast.success({ message: event.payload.message, description });
          }

          break;
        case 'notice':
          if (event.payload.message) {
            toast.notice({ message: event.payload.message, description });
          }

          break;
        case 'attention':
          if (event.payload.message) {
            toast.attention({ message: event.payload.message, description });
          }

          break;
        case 'default':
          if (event.payload.message) {
            toast({ message: event.payload.message, description });
          }

          break;
        default:
      }
    });

    return () => {
      unsubscribe();
    };
  }, [t]);
};

export default useNotificationEvents;
